var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"modal",attrs:{"id":"modal-prevent-closing","ok-title":'Ok',"title":_vm.modalTitle,"modal-class":"edit-title","size":"lg","hide-footer":""},on:{"hidden":_vm.resetModal,"ok":_vm.handleModalOk}},[_c('b-row',[_c('b-col',[_c('video',{attrs:{"width":"100%","src":_vm.srcVideo,"controls":"true"}})])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }